import styled from 'styled-components';
import StyleData from '../../utilities/StyleData';

export const ToggleButton = styled.button<{ $mobile: boolean }>`
  border: 1px solid ${StyleData.color.secondary};
  color: ${StyleData.color.secondary};
  background: ${StyleData.color.base};
  transition: all ${StyleData.transition.duration.short} ${StyleData.transition.timingFunction.short};
  font-family: ${StyleData.font.primary};
  font-size: ${(props) => (props.$mobile ? StyleData.fsize.xs : StyleData.fsize.sm)};
  padding: ${StyleData.spacing.sm} ${StyleData.spacing.md};

  &[data-selected='true'] {
    color: ${StyleData.color.base};
    background: ${StyleData.color.secondary};
  }

  &:first-child {
    border-radius: 999px 0 0 999px;
  }

  &:last-child {
    border-radius: 0 999px 999px 0;
  }

  &:not(:first-child) {
    border-left: 0px;
  }
`;

export const Root = styled.div`
  display: flex;
`;
